export default __webpack_public_path__ + "static/media/enterprise-column.2a22e153.svg";